/**
 * @generated SignedSource<<1bcc58065eae5b4938d59ea01eb6cae6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTransactionQueryRenderer_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_deliveryOptions">;
  readonly " $fragmentType": "CheckoutTransactionQueryRenderer_deliveryOptions";
}>;
export type CheckoutTransactionQueryRenderer_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutTransactionQueryRenderer_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutTransactionQueryRenderer_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutLayout_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "6a121fa49fcede05a0828e039fe09c69";

export default node;
